import { render, staticRenderFns } from "./TabletCharacter.vue?vue&type=template&id=e9350baa&scoped=true&"
import script from "./TabletCharacter.vue?vue&type=script&lang=js&"
export * from "./TabletCharacter.vue?vue&type=script&lang=js&"
import style0 from "./TabletCharacter.vue?vue&type=style&index=0&id=e9350baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9350baa",
  null
  
)

export default component.exports